import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import MotiveTitle from '../../../Contact/Motive/MotiveTitle';
import ProductPreview from '../../../../common/ProductPreview';
import AppInput from '../../../../common/AppInput';
import Message from '../../../../common/Message';
import Loader from '../../../../common/Loader';
import { textMapper } from '../../../../../helpers/FormHelper';
import { useReverseOutOfTimeStyles } from './styles';
import {
  COMPLETE_FORM,
  CREDIT_NOTE_REVERSE_STATUS,
} from '../../../../../constants/texts';

const Form = ({ ...props }) => {
  const { state, onData, fields, mobile, motiveId, setShowForm } = props;
  const classes = useReverseOutOfTimeStyles({ mobile });
  const { messages, status, getStatus, innerMessage } = useSelector(
    (state) => state.validationProductSlice,
  );

  const setMessage = messages.length > 0;

  let loadingGif = getStatus === 'loading';

  const handleChange = (e) => {
    onData({ name: e.target.name, value: e.target.value });
  };

  useEffect(() => {
    setShowForm(status);
  }, [status]);

  useEffect(() => {
    if (loadingGif) setShowForm(false);
    else setShowForm(status);
  }, [loadingGif]);

  return (
    <React.Fragment>
      <MotiveTitle
        title={textMapper.get(motiveId).title}
        subtitle={textMapper.get(motiveId).subtitle}
        icon={textMapper.get(motiveId).icon}
        mobile={mobile}
      />

      {loadingGif && <Loader mobile={mobile} />}

      {!loadingGif && (
        <React.Fragment>
          <ProductPreview mobile={mobile} />

          {setMessage && (
            <Message
              severity="info"
              mobile={mobile}
              message={
                innerMessage.includes('Chek')
                  ? CREDIT_NOTE_REVERSE_STATUS
                  : messages
              }
              fullRounded
            />
          )}

          {status && (
            <React.Fragment>
              <Typography className={classes.title}>{COMPLETE_FORM}</Typography>
              {fields.map((field, index) => (
                <React.Fragment key={index}>
                  {!field.hidden && (
                    <AppInput
                      onChange={handleChange}
                      onBlur={() => {}}
                      onClick={() => {}}
                      disabled={state[field.name]?.disabled || false}
                      name={field.name}
                      error={state[field.name]?.error || false}
                      type={state[field.name]?.type || ''}
                      label={state[field.name]?.label || ''}
                      required={state[field.name]?.required || false}
                      inputAdornment={state[field.name]?.inputAdornment || ''}
                      success={state[field.name]?.success || ''}
                      helperText={state[field.name]?.helper || ''}
                      multiline={state[field.name]?.multiline || false}
                      rows={state[field.name]?.rows || ''}
                      value={state[field.name]?.value || ''}
                      errorMessage={state[field.name]?.message || ''}
                    />
                  )}
                </React.Fragment>
              ))}
            </React.Fragment>
          )}
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

Form.propTypes = {
  state: PropTypes.object,
  onData: PropTypes.func,
  fields: PropTypes.array,
  mobile: PropTypes.bool,
  motiveId: PropTypes.string,
  setShowForm: PropTypes.bool,
};

export default Form;
